<template>
  <AnalyticsTemplate 
    page-title="桥梁超速统计"
    chart-type="overspeed"
  />
</template>

<script>
import AnalyticsTemplate from './AnalyticsTemplate.vue'

export default {
  name: 'OverspeedAnalytics',
  components: {
    AnalyticsTemplate
  }
}
</script>
